const motionTokens = {
  scale: {
    subtle: 1.05,
    medium: 1.12,
    strong: 1.2
  },
  press: {
    subtle: 0.98,
    medium: 0.96,
    strong: 0.92
  },
  translate: {
    subtle: "4px",
    medium: "6px",
    strong: "8px"
  },
  duration: {
    short: 150,
    medium: 220
  },
  easing: {
    standard: "cubic-bezier(0.2, 0, 0, 1)",
    emphasized: "cubic-bezier(0.2, 0, 0, 1)"
  }
}

export default motionTokens
